/* TSM Tracht entdecken. Interaktive Trachtenfigur mit Hotspots und Auswahl. */
(() => {
  const POS = {
    'frau-haar':[180,60,'L',60],'frau-ohr':[231,109,'R',96],'frau-hals':[200,149,'L',150],'frau-tuch':[200,210,'R',200],
    'frau-mieder':[200,256,'L',258],'frau-schuerze':[200,299,'R',300],'frau-charivari':[248,342,'R',372],'frau-tasche':[137,414,'L',414],
    'frau-stola':[140,182,'L',205],'frau-beine':[212,690,'R',690],
    'mann-hut':[229,46,'R',40],'mann-krawatte':[200,192,'L',192],'mann-weste':[200,276,'R',268],'mann-guertel':[200,326,'L',326],
    'mann-charivari':[200,372,'R',372],'mann-messer':[165,430,'L',446]
  };
  const NS = 'http://www.w3.org/2000/svg';
  const euro = c => (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Stellen, die der Set-Vorschlag fuellt: Schmuck plus Tasche. Groessenware (Strumpfhose, Stola) waehlt man selbst.
  const SET = ['frau-haar','frau-ohr','frau-hals','frau-tuch','frau-mieder','frau-schuerze','frau-tasche','mann-hut','mann-krawatte','mann-weste','mann-charivari'];
  const FREE = 5000;
  const STORE = 'tsm-tracht-auswahl';
  const toneOf = t => { t = (t || '').toLowerCase(); if (/silber|nickel|chrom/.test(t)) return 'silber'; if (/gold|messing|bronze|kupfer/.test(t)) return 'gold'; return null; };

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const data = JSON.parse(root.querySelector('[data-tt-data]').textContent);
    const $ = s => root.querySelector(s);
    const svg = $('[data-svg]'), spotsEl = $('[data-spots]'), callEl = $('[data-callouts]'), glow = $('[data-glow]');
    const detail = $('[data-detail]'), empty = $('[data-empty]'), gw = $('[data-gwand]'), panel = $('[data-panel]'), stage = $('[data-stage]');
    const sugBtn = $('[data-suggest]'), sugLabel = $('[data-suggest-l]');
    const mq = window.matchMedia('(max-width: 989px)');
    let fig = 'frau', tone = 'silber';
    const toneOn = !!root.querySelector('[data-tone]');
    if (!toneOn) tone = null;
    const outfit = new Map();
    const uid = root.id || ('tt' + Math.random().toString(36).slice(2, 7));
    root.querySelectorAll('[data-figure]').forEach(f => { f.id = `${uid}-fig-${f.dataset.figure}`; });
    const defs = svg.querySelector('defs');
    const cp = document.createElementNS(NS, 'clipPath'); cp.id = `${uid}-clip`;
    cp.innerHTML = '<circle r="100"/>'; defs.appendChild(cp);
    const loupe = document.createElementNS(NS, 'g'); loupe.setAttribute('class', 'tt__loupe');
    loupe.innerHTML = `<line class="tt__loupe-line"/><g class="tt__loupe-in"><circle class="tt__loupe-bg" r="100"/><g clip-path="url(#${uid}-clip)"><use class="tt__loupe-use"/><image class="tt__loupe-photo" x="-100" y="-100" width="200" height="200" preserveAspectRatio="xMidYMid slice"/></g><circle class="tt__loupe-ring" r="100"/><circle class="tt__loupe-ring2" r="107"/><text class="tt__loupe-cap" y="128" text-anchor="middle"></text></g>`;
    svg.appendChild(loupe);
    const lUse = loupe.querySelector('use'), lLine = loupe.querySelector('line'), lPhoto = loupe.querySelector('image'), lCap = loupe.querySelector('text');
    let current = null, photoT = 0, lastSpotBtn = null;

    const vb = () => mq.matches ? [180, 20, 400, 810] : [0, 20, 760, 810];
    const pct = key => { const v = vb(), p = POS[key]; return [((p[0] + 180 - v[0]) / v[2]) * 100, ((p[1] - v[1]) / v[3]) * 100]; };
    const spotOf = key => data.spots.find(x => x.key === key);

    const pTone = p => toneOf(p.title);
    const vFor = p => {
      const av = p.variants.filter(v => v.a);
      const list = av.length ? av : p.variants;
      return (tone && list.find(v => toneOf(v.t) === tone)) || list[0];
    };
    const fits = p => { if (!tone) return true; const pt = pTone(p); if (pt) return pt === tone; return p.variants.some(v => toneOf(v.t) === tone) || !p.variants.some(v => toneOf(v.t)); };
    const sorted = list => list.map((p, i) => ({ p, i, s: (p.available ? 0 : 4) + (fits(p) ? 0 : 2) })).sort((a, b) => a.s - b.s || a.i - b.i).map(x => x.p);
    const base = t => (t || '').toLowerCase().replace(/(^|\s)(silbern\w*|golden\w*|silberfarben\w*|goldfarben\w*|versilbert\w*|vergoldet\w*|in altsilber|in silber|in gold)(?=\s|$)/g, ' ').replace(/\s+/g, ' ').trim();
    const label = (p, v) => p.title + (!p.single && p.variants.length > 1 && v ? ' · ' + v.t : '');

    /* ---------- Speichern: Auswahl bleibt beim Stoebern im Shop erhalten ---------- */
    function save() {
      try { sessionStorage.setItem(STORE, JSON.stringify({ tone, items: [...outfit.values()].map(o => ({ key: o.key, url: o.url, variant: o.variant })) })); } catch (e) {}
    }
    function restore() {
      let st = null;
      try { st = JSON.parse(sessionStorage.getItem(STORE) || 'null'); } catch (e) {}
      if (!st) return;
      if (toneOn && (st.tone === 'gold' || st.tone === 'silber')) setToneUI(st.tone);
      (st.items || []).forEach(it => {
        const s = spotOf(it.key); const p = s && s.products.find(x => x.url === it.url); if (!p) return;
        const v = p.variants.find(x => x.id === it.variant && x.a); if (!v) return;
        outfit.set(s.key, { key: s.key, url: p.url, title: label(p, v), img: p.img, variant: v.id, price: v.p });
      });
    }

    function layout() {
      svg.setAttribute('viewBox', vb().join(' '));
      spotsEl.querySelectorAll('[data-key]').forEach(el => { const [x, y] = pct(el.dataset.key); el.style.left = x + '%'; el.style.top = y + '%'; });
    }

    function buildFigure() {
      spotsEl.innerHTML = ''; callEl.innerHTML = '';
      data.spots.filter(s => s.key.startsWith(fig + '-')).forEach((s, i) => {
        const p = POS[s.key]; if (!p) return;
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'tt__spot'; b.dataset.key = s.key;
        b.style.setProperty('--d', (i * 0.35) + 's');
        b.setAttribute('aria-label', s.title + (s.where ? ', ' + s.where : ''));
        b.addEventListener('click', () => { lastSpotBtn = b; open(s.key); });
        b.addEventListener('mouseenter', () => peek(s.key, true));
        b.addEventListener('mouseleave', () => peek(s.key, false));
        spotsEl.appendChild(b);
        const g = document.createElementNS(NS, 'g'); g.setAttribute('class', 'co'); g.dataset.key = s.key; g.dataset.side = p[2];
        const x0 = p[0] + 180, y0 = p[1], side = p[2], ly = p[3];
        const xl = side === 'L' ? 150 : 610, xe = side === 'L' ? 166 : 594;
        const xk = side === 'L' ? Math.min(x0 - 28, 250) : Math.max(x0 + 28, 510);
        const pl = document.createElementNS(NS, 'path');
        pl.setAttribute('d', `M${x0 + (side === 'L' ? -9 : 9)},${y0} L${xk},${ly} L${xe},${ly}`);
        pl.setAttribute('pathLength', '1');
        const dot = document.createElementNS(NS, 'circle'); dot.setAttribute('class', 'co-dot');
        dot.setAttribute('cx', xe); dot.setAttribute('cy', ly); dot.setAttribute('r', 1.8);
        const t = document.createElementNS(NS, 'text');
        t.setAttribute('x', xl); t.setAttribute('y', ly + 4);
        t.setAttribute('text-anchor', side === 'L' ? 'end' : 'start');
        t.textContent = s.title.length > 22 ? s.title.split(' & ')[0] : s.title;
        const hit = document.createElementNS(NS, 'rect');
        hit.setAttribute('class', 'co-hit'); hit.setAttribute('y', ly - 14); hit.setAttribute('height', 28);
        hit.setAttribute('x', side === 'L' ? 0 : 590); hit.setAttribute('width', 170);
        g.style.setProperty('--d', (0.9 + i * 0.08) + 's');
        g.append(hit, pl, dot, t);
        g.addEventListener('click', () => { lastSpotBtn = spotsEl.querySelector(`.tt__spot[data-key="${s.key}"]`); open(s.key); });
        g.addEventListener('mouseenter', () => peek(s.key, true));
        g.addEventListener('mouseleave', () => peek(s.key, false));
        callEl.appendChild(g);
      });
      outfit.forEach((o, key) => { if (key.startsWith(fig + '-')) addPin(key, o, false); });
      layout();
    }

    function peek(key, on) {
      if (root.classList.contains('has-focus')) return;
      callEl.querySelectorAll('.co').forEach(c => c.classList.toggle('is-peek', on && c.dataset.key === key));
      root.querySelectorAll('.tt__figwrap.is-active .tt-part').forEach(g => g.classList.toggle('is-peek', on && g.dataset.spot === key.split('-')[1]));
    }

    function draw() {
      const w = root.querySelector(`[data-figure="${fig}"]`);
      root.querySelectorAll('[data-figure]').forEach(f => f.classList.toggle('is-active', f === w));
      root.classList.remove('is-drawn'); w.classList.remove('is-drawing'); void w.getBBox(); w.classList.add('is-drawing');
      setTimeout(() => root.classList.add('is-drawn'), reduce ? 0 : 900);
    }

    function setFig(f) {
      if (f === fig || !root.querySelector(`[data-figure="${f}"]`)) return;
      fig = f; root.dataset.fig = f; close(true);
      root.querySelectorAll('.tt__tab').forEach(t => { const on = t.dataset.fig === f; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
      buildFigure(); draw(); syncSuggest();
    }

    function fly(fromEl, key, img) {
      const pin = spotsEl.querySelector(`.tt__pin[data-key="${key}"]`);
      if (!fromEl || !pin || reduce) return;
      const a = fromEl.getBoundingClientRect(), b = pin.getBoundingClientRect();
      if (!a.width || !b.width) return;
      const f = document.createElement('div'); f.className = 'tt__fly';
      f.innerHTML = `<img alt="" src="${img}">`;
      Object.assign(f.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px', transformOrigin: '0 0' });
      document.body.appendChild(f);
      pin.style.opacity = '0';
      const dx = b.left - a.left, dy = b.top - a.top, s = b.width / a.width;
      f.animate([
        { transform: 'translate(0,0) scale(1)', borderRadius: '4px' },
        { transform: `translate(${dx * 0.55}px,${dy * 0.55 - 60}px) scale(${(1 + s) / 2})`, borderRadius: '50%', offset: 0.55 },
        { transform: `translate(${dx}px,${dy}px) scale(${s})`, borderRadius: '50%' }
      ], { duration: 750, easing: 'cubic-bezier(.5,0,.2,1)', fill: 'forwards' }).onfinish = () => { f.remove(); pin.style.opacity = ''; pin.classList.remove('is-new'); void pin.offsetWidth; pin.classList.add('is-new'); };
    }

    function pick(spot, p, variantId, fromEl) {
      const v = p.variants.find(x => x.id === variantId) || p.variants.find(x => x.a) || p.variants[0];
      const o = { key: spot.key, url: p.url, title: label(p, v), img: p.img, variant: v.id, price: v.p };
      outfit.set(spot.key, o); addPin(spot.key, o, !fromEl); fly(fromEl, spot.key, p.img); renderGwand();
    }

    function unpick(key) { outfit.delete(key); removePin(key); renderGwand(); }

    function variantSelect(p, first) {
      const sel = document.createElement('select'); sel.className = 'tt__csel'; sel.setAttribute('aria-label', 'Ausführung wählen');
      const split = p.variants.every(v => v.t.includes(' / '));
      const groups = new Map();
      p.variants.forEach(v => {
        const o = document.createElement('option'); o.value = v.id; o.disabled = !v.a;
        let parent = sel, txt = v.t;
        if (split) {
          const i = v.t.indexOf(' / '), g = v.t.slice(0, i); txt = v.t.slice(i + 3);
          if (!groups.has(g)) { const og = document.createElement('optgroup'); og.label = g; groups.set(g, og); sel.appendChild(og); }
          parent = groups.get(g);
        }
        o.textContent = txt + (v.a ? '' : ' (ausverkauft)');
        parent.appendChild(o);
      });
      if (first) sel.value = first.id;
      return sel;
    }

    function card(p, spot) {
      const el = document.createElement('div'); el.className = 'tt__card';
      const o0 = outfit.get(spot.key);
      const first = (o0 && o0.url === p.url && p.variants.find(v => v.id === o0.variant)) || vFor(p);
      el.innerHTML = `<a class="tt__cimg" href="${p.url}"><img loading="lazy" alt="" src="${p.img || ''}"></a>
        <div class="tt__cbody"><a class="tt__cname" href="${p.url}"></a><span class="tt__cprice"></span></div>`;
      el.querySelector('.tt__cname').textContent = p.title;
      el.querySelector('img').alt = p.title;
      const body = el.querySelector('.tt__cbody'), priceEl = el.querySelector('.tt__cprice');
      const setPrice = v => { priceEl.textContent = v ? euro(v.p) : ''; };
      setPrice(first);
      let sel = null;
      if (!p.single && p.variants.length > 1) {
        sel = variantSelect(p, first);
        sel.addEventListener('change', () => {
          const v = p.variants.find(x => x.id === +sel.value); setPrice(v);
          const o = outfit.get(spot.key);
          if (o && o.url === p.url && v) { o.variant = v.id; o.price = v.p; o.title = label(p, v); renderGwand(); }
        });
        body.appendChild(sel);
      }
      const btn = document.createElement('button'); btn.type = 'button'; btn.className = 'tt__cbtn';
      const isOn = () => { const o = outfit.get(spot.key); return !!(o && o.url === p.url); };
      const sync = () => {
        const on = isOn();
        el.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', String(on));
        if (!p.available) { btn.disabled = true; btn.textContent = 'Ausverkauft'; return; }
        btn.innerHTML = on ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"/></svg>Angelegt' : 'Anlegen';
        btn.title = on ? 'Nochmal tippen zum Ablegen' : '';
      };
      sync();
      btn.addEventListener('click', () => {
        if (isOn()) unpick(spot.key);
        else pick(spot, p, sel ? +sel.value : first.id, el.querySelector('.tt__cimg'));
        syncCards();
      });
      el.addEventListener('tt:sync', sync);
      body.appendChild(btn);
      return el;
    }
    const syncCards = () => detail.querySelectorAll('.tt__card').forEach(c => c.dispatchEvent(new Event('tt:sync')));

    function renderCards(s) {
      const cards = $('[data-d-cards]'); cards.innerHTML = '';
      sorted(s.products).forEach(p => cards.appendChild(card(p, s)));
    }

    function open(key) {
      const s = spotOf(key); if (!s) return;
      peek(key, false);
      const wasOpen = root.classList.contains('is-open');
      root.classList.add('has-focus', 'is-open');
      const part = key.split('-')[1];
      root.querySelectorAll('.tt__figwrap.is-active .tt-part').forEach(g => g.classList.toggle('is-hot', g.dataset.spot === part));
      root.querySelectorAll('.tt__spot').forEach(b => b.classList.toggle('is-hot', b.dataset.key === key));
      const p = POS[key];
      callEl.querySelectorAll('.co').forEach(c => { c.classList.toggle('is-hot', c.dataset.key === key); c.classList.toggle('is-under', c.dataset.key !== key && c.dataset.side !== p[2]); });
      glow.setAttribute('transform', `translate(${p[0] + 180} ${p[1]})`);
      const hx = p[0] + 180, hy = p[1], lx = p[2] === 'L' ? 652 : 108, ly = Math.max(130, Math.min(680, hy + 40));
      loupe.setAttribute('transform', `translate(${lx} ${ly})`);
      lUse.setAttribute('href', `#${uid}-fig-${fig}`);
      lUse.setAttribute('transform', `scale(2.6) translate(${-hx} ${-hy})`);
      const dx = hx - lx, dy = hy - ly, len = Math.hypot(dx, dy) || 1;
      lLine.setAttribute('x1', dx * (1 - 14 / len)); lLine.setAttribute('y1', dy * (1 - 14 / len));
      lLine.setAttribute('x2', dx / len * 110); lLine.setAttribute('y2', dy / len * 110);
      if (mq.matches) {
        const sb = root.querySelector(`.tt__spot[data-key="${key}"]`);
        if (sb) { const r = sb.getBoundingClientRect(); if (r.top < 60 || r.top > innerHeight * 0.36) window.scrollBy({ top: r.top - innerHeight * 0.2, behavior: reduce ? 'auto' : 'smooth' }); }
      }
      current = key; clearTimeout(photoT); loupe.classList.remove('show-photo');
      lCap.textContent = s.worn ? (s.wornCap || 'Aus der Manufaktur') : '';
      if (s.worn) { lPhoto.setAttribute('href', s.worn); photoT = setTimeout(() => { if (current === key) loupe.classList.add('show-photo'); }, reduce ? 0 : 700); }
      const wf = $('[data-d-worn]');
      if (s.worn) { wf.hidden = false; const wi = wf.querySelector('img'); wi.src = s.worn; wi.alt = s.wornAlt || ''; $('[data-d-worn-cap]').textContent = s.wornCap || ''; $('[data-d-worn-alt]').textContent = s.wornAlt || ''; } else wf.hidden = true;
      setHash(key);
      empty.hidden = true; detail.hidden = false;
      $('[data-d-where]').textContent = s.where || (fig === 'frau' ? 'Zum Dirndl' : 'Zur Lederhose');
      $('[data-d-title]').textContent = s.title;
      $('[data-d-text]').textContent = s.text;
      renderCards(s);
      const coll = $('[data-d-coll]');
      if (s.coll) { coll.hidden = false; coll.href = s.coll; coll.textContent = 'Alle ' + (s.collTitle || '') + ' ansehen'; } else coll.hidden = true;
      const gl = $('[data-d-guide]');
      if (s.guide) { gl.hidden = false; gl.href = s.guide; $('[data-d-guide-label]').textContent = s.guideLabel || 'Zum Ratgeber'; } else gl.hidden = true;
      panel.scrollTop = 0;
      detail.classList.remove('is-in'); void detail.offsetWidth; detail.classList.add('is-in');
      if (mq.matches && !wasOpen) setTimeout(() => { const c = $('[data-close]'); if (c) c.focus({ preventScroll: true }); }, 50);
    }

    function setHash(key) {
      if (!root.hasAttribute('data-tt-hash')) return;
      try { history.replaceState(null, '', key ? '#' + key : location.pathname + location.search); } catch (e) {}
    }

    function fromHash() {
      const h = decodeURIComponent((location.hash || '').slice(1)).toLowerCase();
      if (!h) return null;
      const keys = data.spots.map(x => x.key);
      return keys.includes(h) ? h : (keys.find(k => k.split('-')[1] === h) || null);
    }

    function close(silent) {
      const was = root.classList.contains('is-open');
      current = null; clearTimeout(photoT); loupe.classList.remove('show-photo');
      if (was) setHash(null);
      root.classList.remove('has-focus', 'is-open');
      root.querySelectorAll('.is-hot').forEach(e => e.classList.remove('is-hot'));
      empty.hidden = false; detail.hidden = true;
      panel.style.transform = '';
      if (was && !silent && mq.matches && lastSpotBtn && lastSpotBtn.isConnected) lastSpotBtn.focus({ preventScroll: true });
    }

    function addPin(key, o, pop) {
      if (!key.startsWith(fig + '-')) return;
      removePin(key);
      const p = POS[key];
      const pin = document.createElement('span');
      pin.className = 'tt__pin' + (p[2] === 'L' ? ' is-left' : '') + (pop ? ' is-new' : '');
      pin.dataset.key = key;
      pin.innerHTML = `<img alt="" src="${o.img}">`;
      spotsEl.appendChild(pin); layout();
    }
    function removePin(key) { spotsEl.querySelectorAll(`.tt__pin[data-key="${key}"]`).forEach(n => n.remove()); }

    function renderGwand() {
      gw.hidden = outfit.size === 0;
      const items = $('[data-g-items]'); items.innerHTML = '';
      let sum = 0;
      outfit.forEach(o => {
        sum += o.price;
        const b = document.createElement('button'); b.type = 'button'; b.className = 'tt__gitem';
        b.setAttribute('aria-label', o.title + ', ansehen'); b.title = o.title;
        b.innerHTML = `<img alt="" src="${o.img}">`;
        b.addEventListener('click', () => { const f = o.key.split('-')[0]; if (f !== fig) setFig(f); lastSpotBtn = null; open(o.key); if (!mq.matches) stage.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); });
        items.appendChild(b);
      });
      $('[data-g-count]').textContent = outfit.size === 1 ? 'Deine Auswahl · 1 Teil' : `Deine Auswahl · ${outfit.size} Teile`;
      $('[data-g-sum]').textContent = euro(sum);
      const sh = $('[data-g-ship]');
      if (sh) sh.textContent = sum >= FREE ? 'Versandkostenfrei in Deutschland' : `Noch ${euro(FREE - sum)} bis versandkostenfrei`;
      $('[data-g-msg]').hidden = true;
      const add = $('[data-g-add]'); add.disabled = false; add.textContent = 'Alles in den Warenkorb';
      syncSuggest(); save();
    }

    /* ---------- Set-Vorschlag: fuellt freie Stellen, beim zweiten Klick ein anderes Set ---------- */
    const setSpots = () => data.spots.filter(s => s.key.startsWith(fig + '-') && SET.includes(s.key) && s.products.some(p => p.available));
    const setFull = () => { const sp = setSpots(); return sp.length > 0 && sp.every(s => outfit.has(s.key)); };
    function syncSuggest() { if (sugLabel) sugLabel.textContent = setFull() ? 'Anderes Set' : 'Set vorschlagen'; }
    sugBtn.addEventListener('click', () => {
      close(true);
      const full = setFull();
      let n = 0;
      setSpots().forEach(s => {
        const list = sorted(s.products).filter(x => x.available);
        const cur = outfit.get(s.key);
        let p;
        if (full) { const i = list.findIndex(x => cur && x.url === cur.url); p = list[(i + 1) % list.length]; if (cur && p.url === cur.url) return; }
        else if (cur) return;
        else p = list[0];
        if (!p) return;
        setTimeout(() => pick(s, p, vFor(p).id, null), reduce ? 0 : n++ * 180);
      });
    });

    /* ---------- Warenkorb: an die Theme-Ereignisse angebunden, Teilfehler werden einzeln gemeldet ---------- */
    async function addToCart(items) {
      const sections = [...document.querySelectorAll('cart-items-component[data-section-id]')].map(e => e.dataset.sectionId).join(',');
      let Ev = null;
      try { Ev = (await import('@shopify/events')).CartLinesUpdateEvent; } catch (e) {}
      const def = Ev && Ev.createPromise ? Ev.createPromise() : null;
      if (def) root.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: items.map(i => ({ merchandiseId: String(i.id), quantity: i.quantity })), promise: def.promise }));
      const post = body => fetch(data.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(async r => ({ ok: r.ok, j: await r.json().catch(() => ({})) }));
      const failed = [];
      let secs;
      try {
        const res = await post(sections ? { items, sections } : { items });
        if (res.ok) secs = res.j.sections;
        else for (const it of items) { const r = await post({ items: [it] }); if (!r.ok) failed.push(it.id); }
        const cart = await fetch(data.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        if (def) def.resolve({ cart: Ev.createCartFromAjaxResponse ? Ev.createCartFromAjaxResponse(cart) : undefined, detail: { items: cart.items, source: 'tsm-tracht', itemCount: cart.item_count, sections: secs, didError: failed.length === items.length } });
        else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (err) {
        if (def) def.reject(err);
        throw err;
      }
      return failed;
    }

    $('[data-g-add]').addEventListener('click', async e => {
      const btn = e.currentTarget, msg = $('[data-g-msg]');
      if (!outfit.size) return;
      btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
      const list = [...outfit.values()];
      try {
        const failed = await addToCart(list.map(o => ({ id: o.variant, quantity: 1 })));
        const ok = list.length - failed.length;
        if (!ok) throw new Error('Die Teile sind gerade nicht verfügbar.');
        const miss = list.filter(o => failed.includes(o.variant)).map(o => o.title);
        msg.innerHTML = '';
        msg.append(ok === 1 ? '1 Teil liegt im Warenkorb. ' : `${ok} Teile liegen im Warenkorb. `);
        if (miss.length) msg.append(`Nicht mehr verfügbar: ${miss.join(', ')}. `);
        const a = document.createElement('a'); a.href = data.cartUrl; a.textContent = 'Zum Warenkorb'; msg.append(a);
        btn.textContent = 'Im Warenkorb';
      } catch (err) {
        msg.textContent = 'Das hat nicht geklappt. ' + (err && err.message && !/fetch/i.test(err.message) ? err.message : 'Bitte versuch es noch einmal.');
        btn.textContent = 'Alles in den Warenkorb';
      }
      msg.hidden = false; btn.disabled = false;
    });
    $('[data-g-clear]').addEventListener('click', () => { outfit.clear(); spotsEl.querySelectorAll('.tt__pin').forEach(n => n.remove()); renderGwand(); syncCards(); });

    /* ---------- Figur-Tabs mit Pfeiltasten ---------- */
    const tabs = [...root.querySelectorAll('.tt__tab')];
    tabs.forEach(t => {
      t.tabIndex = t.dataset.fig === fig ? 0 : -1;
      t.addEventListener('click', () => setFig(t.dataset.fig));
      t.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const n = tabs[(tabs.indexOf(t) + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        setFig(n.dataset.fig); n.focus();
      });
    });

    /* ---------- Metallton ---------- */
    function setToneUI(t) {
      tone = t; root.dataset.tone = t;
      root.querySelectorAll('[data-tone]').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.tone === t)));
    }
    root.querySelectorAll('[data-tone]').forEach(b => b.addEventListener('click', () => {
      if (b.dataset.tone === tone) return;
      setToneUI(b.dataset.tone);
      outfit.forEach((o, key) => {
        const s = spotOf(key); const p = s && s.products.find(x => x.url === o.url); if (!p) return;
        if (pTone(p) && pTone(p) !== tone) {
          // Gleiches Stueck im anderen Metall vorhanden? Dann tauschen (z. B. silberne gegen goldene Ohrringe)
          const q = s.products.find(x => x !== p && x.available && pTone(x) === tone && base(x.title) === base(p.title));
          if (q) {
            const old = p.variants.find(v => v.id === o.variant);
            const v = (old && q.variants.find(x => x.a && x.t === old.t)) || vFor(q);
            Object.assign(o, { url: q.url, img: q.img, variant: v.id, price: v.p, title: label(q, v) });
            addPin(key, o, true); return;
          }
        }
        const v = p.variants.find(x => x.a && toneOf(x.t) === tone); if (!v) return;
        o.variant = v.id; o.price = v.p; o.title = label(p, v);
      });
      renderGwand();
      if (current) { const s = spotOf(current); if (s) renderCards(s); }
    }));
    if (toneOn) setToneUI(tone);

    /* ---------- Schliessen: Knopf, Escape, Klick daneben, auf dem Handy nach unten wischen ---------- */
    $('[data-close]').addEventListener('click', () => close());
    root.addEventListener('keydown', e => { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
    stage.addEventListener('click', e => { if (e.target.closest('.tt__spot, .co')) return; if (root.classList.contains('is-open')) close(true); });
    let ty = null, tdy = 0;
    panel.addEventListener('touchstart', e => { if (!mq.matches || panel.scrollTop > 0) { ty = null; return; } ty = e.touches[0].clientY; tdy = 0; }, { passive: true });
    panel.addEventListener('touchmove', e => { if (ty === null) return; tdy = e.touches[0].clientY - ty; if (tdy > 0) { panel.style.transition = 'none'; panel.style.transform = `translateY(${tdy}px)`; } }, { passive: true });
    panel.addEventListener('touchend', () => { if (ty === null) return; panel.style.transition = ''; if (tdy > 90) close(); else panel.style.transform = ''; ty = null; });

    mq.addEventListener('change', layout);
    root.dataset.fig = 'frau';
    restore();
    buildFigure();
    renderGwand();
    const deep = fromHash();
    if (deep) {
      const f = deep.split('-')[0];
      if (f !== fig) { fig = f; root.dataset.fig = f; tabs.forEach(t => { const on = t.dataset.fig === f; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; }); buildFigure(); syncSuggest(); }
      draw();
      stage.scrollIntoView({ block: mq.matches ? 'start' : 'center' });
      setTimeout(() => open(deep), reduce ? 0 : 1500);
    } else {
      const io = new IntersectionObserver(es => { if (es[0].isIntersecting) { draw(); io.disconnect(); } }, { threshold: 0.2 });
      io.observe(svg);
    }
    window.addEventListener('hashchange', () => { const k = fromHash(); if (!k || k === current) return; if (k.split('-')[0] !== fig) setFig(k.split('-')[0]); setTimeout(() => open(k), reduce ? 0 : 900); });
  }

  const boot = () => document.querySelectorAll('[data-tt]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
